import { RapidColorHEX } from '@genesislcap/foundation-zero';
import { foundationGridProStyles } from '@genesislcap/grid-pro';
import { css } from '@microsoft/fast-element';
import { agThemeGenesisRapid, agThemeGenesisRapidDark } from './themes';
export const zeroGridProStyles = css `
  /* All the AG themes */
  ${foundationGridProStyles}

  /* 100% custom, CSS based, our own name: ag-theme-genesis-rapid */
  ${agThemeGenesisRapid}
  ${agThemeGenesisRapidDark}

  .error {
    border-color: ${RapidColorHEX.shortPink} !important;
  }
`;
